import React from 'react';
import ButtonTwo from '../../components/Button/ButtonTwo';
import SingleServiceSix from '../../components/Service/SingleServiceSix';

import shapeImg from '../../assets/img/service/shape-5-1.png';
import serviceImg from '../../assets/img/service/service-5-1.jpg';

const Service = () => {
  return (
    <div
      id="it-service"
      className="it-service-4-area z-index grey-bg-4 pt-120 pb-90"
    >
      <div className="it-service-4-shape-1 d-none d-xl-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-service-4-title-wrap mb-60">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="it-service-title-box">
                <span className="it-section-subtitle red-border">Services</span>
                <h3 className="it-section-title">
                  Take The Road To A <br /> Healthy Heart Beat
                </h3>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="it-service-4-button text-md-end">
                <ButtonTwo
                  btnURL="/about-us"
                  btnClass="it-btn-theme red-bg mr-35"
                  btnText="Discover More"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleServiceSix
              serviceImage={serviceImg}
              icon="flaticon-microsurgery"
              title="Heart Surgery"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleServiceSix
              serviceImage={serviceImg}
              icon="flaticon-heart-disease"
              title="Valve Diseases"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleServiceSix
              serviceImage={serviceImg}
              icon="flaticon-microsurgery"
              title="Heart Surgery"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".8s"
          >
            <SingleServiceSix
              serviceImage={serviceImg}
              icon="flaticon-heart"
              title="Cardiovascular Care"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1s"
          >
            <SingleServiceSix
              serviceImage={serviceImg}
              icon="flaticon-i-love-you"
              title="Heart Screening"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.1s"
          >
            <SingleServiceSix
              serviceImage={serviceImg}
              icon="flaticon-pacemaker"
              title="Pacemaker Implant"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
